/* const InfoCircle = ({ value, label }) => {
  return (
    <div className="flex flex-col">
      <div className="flex  justify-center w-10 h-10 items-center  rounded-full bg-white/80 text-black">
        {value}
      </div>
      <div className="flex flex-col justify-center items-center font-medium text-md text-white text-xs">
        {label}
      </div>
    </div>
  );
}; */

const InfoCircle = ({ value, label }) => {
  return (
    <div className="flex flex-col bg-black/60 rounded-md text-white p-2 w-16">
      <div className="flex  justify-center items-center    font-semibold">
        {value}
      </div>
      <div className="flex flex-col justify-center items-center font-light text-xs">
        {label}
      </div>
    </div>
  );
};

export default InfoCircle;
